import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '../TextField';
import { IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const Datepicker = (props) => {
  const {
    size = 'normal',
    error = false,
    readOnly = true,
    helperText = '',
    value,
    onChange,
    disabled,
    onKeyDown,
    InputProps,
    ...others
  } = props;

  const handleClear = (event) => {
    event.stopPropagation();
    onChange(null);
  };

  const handleKeyDown = (event) => {
    if (disabled && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        {...others}
        value={value}
        onChange={onChange}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            size={size}
            {...params}
            error={error}
            helperText={helperText}
            inputProps={{
              ...params.inputProps,
              readOnly: readOnly,
              tabIndex: disabled ? -1 : 0,
            }}
            InputProps={{
              ...params.InputProps,
              ...InputProps,
              tabIndex: disabled ? -1 : 0,
              onKeyDown: handleKeyDown,
              endAdornment: (
                <InputAdornment position="end">
                  {!disabled && value && (
                    <IconButton size="small" onClick={handleClear} edge="end" tabIndex={disabled ? -1 : 0}>
                      <ClearIcon />
                    </IconButton>
                  )}
                  {params.InputProps?.endAdornment}
                </InputAdornment>
              ),
            }}
            disabled={disabled}
            onKeyDown={handleKeyDown}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default Datepicker;
